<ng-container *ngIf="viewType=='MIN'">
  <div class="hpanel-693 margin-bottom-5-693 gs-widget-card"
    *ngIf="userType=='RECRUITER'|| userType=='MANAGEMENT_TALENT_ACQUISITION'|| userType=='FREELANCE_RECRUITER'">
    <app-common-skeleton *ngIf="loadAPIcall" [countforView]="1" [NameOftheScreen]="'widgets'"></app-common-skeleton>
    <ng-container *ngIf="candidatefilter =='false'&&!loadAPIcall|| candidatefilter==undefined&&!loadAPIcall">

      <div class="panel-heading-693 hbuilt-693 widget-header-693 gs-widget-header">
        <span class="header-title-693">Candidates from Connections</span>
        <span class="refresh-icon-693" title="Refresh" (click)="refreshCandidate()">
          <ng-icon name="tablerRefresh"></ng-icon>
        </span>
      </div>
      <div class="panel-body-693 padding-top-6-693 widget-content-693 gs-widget-body">
        <div class="row-693">
          <ul class="profile-list-693">
            <ng-container *ngFor="let item of response | slice:0:3">
              <app-common-profile-info [userIdInput]="item.createdBy" [page]="'CANDIDATES_MIGHT'" [data]="item"
                (click)="redirect(item)" class="candidate-item-693">
                <ng-container headline1>
                  <span class="candidate-name-693">{{item.firstName|titlecase}} {{item.lastName|titlecase}}</span>
                </ng-container>
                <p headline2 class="candidate-job-693" [title]="item.jobTitle">{{item.jobTitle}}</p>
              </app-common-profile-info>
            </ng-container>
            
            <button class="gs-743-more-btn" type="button"
                    *ngIf="candidateCount > 0 && response?.length > 0"
                    (click)="modelopen(response,false,'')">
              View more →
            </button>

            <div class="gs-empty" *ngIf="candidateCount == 0 || response.length == 0">
              <span class="gs-empty-icon"><ng-icon name="tablerUsers"></ng-icon></span>
              <div class="gs-empty-title">No suggestions yet</div>
              <div class="gs-empty-sub">Get connected with people to see candidate suggestions.</div>
            </div>
          </ul>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>


<div class="margin-bottom-5 eyeicon-scroll-container" *ngIf="viewType=='MAX'"
 infiniteScroll [infiniteScrollDistance]="2" [scrollWindow]="false" [infiniteScrollThrottle]="1000" (scrolled)="onScrollDown()">
  <div class="panel-body cardw">
    <div class="row">
      <div class="col-12">
        <app-common-skeleton *ngIf="loadAPIcall" [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>

        <div *ngIf="sugges!=null&& !loadAPIcall">
          <div class="col-md-12 padding-left-0 padding-right-5">
            <app-candidate-card [viewSize]="'large'" [candidateval]="sugges" [From]="'CANDIDATES_FROM_CONNECTION'"></app-candidate-card>

          </div>
        </div>
        <div class="col-md-12 padding-left-0 padding-right-5" *ngIf="response?.length == 0 && !loadAPIcall">
          <div class="gs-empty">
            <span class="gs-empty-icon"><ng-icon name="tablerUsers"></ng-icon></span>
            <div class="gs-empty-title">No candidates to show yet</div>
            <div class="gs-empty-sub">Candidates you might be interested in will appear here.</div>
          </div>
        </div>

        <div *ngIf="sugges==null && !loadAPIcall">
          <div class="col-md-12 padding-left-0 padding-right-5" *ngFor="let item of response">
            <app-candidate-card [viewSize]="'large'" [candidateval]="item"
              [From]="'CANDIDATES_FROM_CONNECTION'"></app-candidate-card>
          </div>
        </div>

        <div class="col-sm-12 gs-end-of-list" *ngIf="stopScroll &&response?.length > 0" style="text-align: center;padding-top: 1rem;">
          <div class="col-sm-12">
            <!-- <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" >
              <path
                d="M15.9047 8.38142C16.2952 7.9909 16.9284 7.9909 17.3189 8.38142C17.7094 8.77195 17.7094 9.40511 17.3189 9.79564L12.0541 15.0592C11.079 16.0341 9.49854 16.0354 8.52183 15.062L6.70711 13.2535C6.31658 12.863 6.31658 12.2298 6.70711 11.8393C7.09763 11.4488 7.7308 11.4488 8.12132 11.8393L9.57698 13.2949C9.9675 13.6855 10.6007 13.6855 10.9912 13.2949L15.9047 8.38142Z"
                fill="#8B5CF6" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 20.9932C7.03321 20.9932 3.00683 16.9668 3.00683 12C3.00683 7.03321 7.03321 3.00683 12 3.00683C16.9668 3.00683 20.9932 7.03321 20.9932 12C20.9932 16.9668 16.9668 20.9932 12 20.9932Z"
                fill="#8B5CF6" />
            </svg> -->
            <ng-icon name="tablerCircleCheck"></ng-icon>
          </div>
          <div class="col-sm-12">
            <p class="biase">You've reached the bottom of the page</p>
          </div>
        </div>

          <!-- <div *ngIf="response === null  || response?.length === 0">
            <div appQueryDOM [response]="resultContent" class="empty-message-container"
              style="float: right; position: relative; top: 150%; right: 32rem; bottom: -4rem; font-size: x-large;">
              <img src='assets/images/empty-page-picture.png' alt="">
              <span id="EmptyMessage" style="margin-top:-30px;" #empty class="empty-message">fetching Candidate...
              </span>
            </div>
          </div> -->



      </div>


    </div>
  </div>

